// extracted by mini-css-extract-plugin
export default {"tabBody":"campaignsTab_tabBody__xLJu+","emptyMessage":"campaignsTab_emptyMessage__sxHxa","campaignCount":"campaignsTab_campaignCount__XNs+W"};